// extracted by mini-css-extract-plugin
export default {"completed":"styles_completed__+yS2f","inProgress":"styles_inProgress__pse+6","cancelled":"styles_cancelled__ZISX1","pending":"styles_pending__Un7B6"};